(function($) {
    $(() => {
        $(() => {
            objectFitImages();
        });

        $('.hardware_dropdown .dropdown-menu').remove();
        $('.software_dropdown .dropdown-menu').remove();
        $('.support_dropdown .dropdown-menu').remove();

        if ($('.hardware_menu_items').length > 0) {
            $('.hardware_dropdown').append($('.hardware_menu_items'));
        } else {
            $('.hardware_dropdown a').addClass('no_after');
            $('.hardware_dropdown .dropdown-menu').remove();
        }
        if ($('.software_menu_items').length > 0) {
            $('.software_dropdown').append($('.software_menu_items'));
        } else {
            $('.software_dropdown a').addClass('no_after');
            $('.software_dropdown .dropdown-menu').remove();
        }
        if ($('.support_menu_items').length > 0) {
            $('.support_dropdown').append($('.support_menu_items'));
        } else {
            $('.support_dropdown a').addClass('no_after');
            $('.support_dropdown .dropdown-menu').remove();
        }

        if ($('#referencePage')[0] && window.location.hash.length > 0) {
            const hash = window.location.hash.slice(1);
            setTimeout(() => {
                $(`.${hash}`)[0].scrollIntoView({
                    behaviour: 'smooth',
                    block: 'nearest',
                    inline: 'start'
                });
                $(`.${hash} .toggleReference`).click();
            }, 100);
        }

        // Header animation on scroll
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 0) {
                $('#menu').addClass('scrolled');
            } else {
                $('#menu').removeClass('scrolled');
            }
        });

        if ($('.js-mh-product-image').length) {
            $('.js-mh-product-image').matchHeight({
                byRow: true
            });
        }

        if ($('.js-mh-hero-img').length) {
            $('.js-mh-hero-img').matchHeight({
                byRow: true
            });
        }

        if ($('.js-mh-name').length) {
            $('.js-mh-name').matchHeight({
                byRow: true
            });
        }

        if ($('.js-mh-reference-text').length) {
            $('.js-mh-reference-text').matchHeight({
                byRow: true
            });
        }

        if ($('.js-mh-products-image').length) {
            $('.js-mh-products-image').matchHeight({
                byRow: true
            });
        }

        if ($('.js-mh-products-name').length) {
            $('.js-mh-products-name').matchHeight({
                byRow: true
            });
        }

        if ($('.js-mh-products-sub').length) {
            $('.js-mh-products-sub').matchHeight({
                byRow: true
            });
        }

        //--------------------------
        //--------------------------

        //--------------------------
        // Toggle reference box
        $('.toggleReference').click(function() {
            $(this).toggleClass('open');
            $(this)
                .closest('.flex')
                .toggleClass('open');
            const extra = $(this)
                .closest('.box')
                .children('.extra');
            $(extra).css('opacity', '0');
            if ($(this).hasClass('open')) {
                $(this).text($(this).data('less'));
            } else {
                $(this).text($(this).data('more'));
            }
            $(extra).slideToggle({
                duration: 300,
                start: () => {
                    $(extra)
                        .children('.refSlider')[0]
                        .slick.refresh();
                    setTimeout(() => {
                        $(extra).css('opacity', '1');
                    }, 200);
                }
            });
        });
        //--------------------------
        //--------------------------

        //--------------------------
        // Reference page sliders
        $('.refSlider').each(function() {
            const slider = this;
            $(slider).on('init reInit', (event, slick, currentSlide = 0) => {
                if (window.innerWidth > 768 && slick.slideCount < 4) {
                    $('#rp_counter').css('display', 'none');
                }

                if (window.innerWidth < 768 && slick.slideCount < 3) {
                    $('#rp_counter').css('display', 'none');
                }

                if (window.innerWidth < 576 && slick.slideCount < 2) {
                    $('#rp_counter').css('display', 'none');
                }
            });
            $(slider).on('afterChange', (event, slick, currentSlide = 0) => {
                $(slider)
                    .closest('.extra')
                    .find('#ref__counter__text')
                    .text(`${currentSlide + 1} / ${slick.slideCount}`);
            });
            $(slider).slick({
                slidesToShow: 3,
                swipeToSlide: true,
                nextArrow: $(slider)
                    .closest('.extra')
                    .find('#ref__next')[0],
                prevArrow: $(slider)
                    .closest('.extra')
                    .find('#ref__prev')[0],
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        });
        //--------------------------
        //--------------------------

        //--------------------------
        // Product page products slider
        $('#productSlider').on('init reInit', (event, slick, currentSlide = 0) => {
            if (window.innerWidth > 768 && slick.slideCount < 4) {
                $('#pp_counter').css('display', 'none');
            }

            if (window.innerWidth < 768 && slick.slideCount < 3) {
                $('#pp_counter').css('display', 'none');
            }

            if (window.innerWidth < 576 && slick.slideCount < 2) {
                $('#pp_counter').css('display', 'none');
            }
        });

        $('#productSlider').on('afterChange', (event, slick, currentSlide = 0) => {
            $('#prod__counter__text').text(`${currentSlide + 1} / ${slick.slideCount}`);
        });

        $('#productSlider').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            slidesToShow: 3,
            nextArrow: $('#prod__next'),
            prevArrow: $('#prod__prev'),
            infinite: false,
            centerMode: false,
            initialSlide: 0,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
        //--------------------------
        //--------------------------

        if (window.innerWidth < 992) {
            $('.nav-link.dropdown-toggle').click(event => {
                event.preventDefault();
            });
        }

        //--------------------------
        // Main page products slider
        $('#products_slider').on('init reinit', (event, slick, currentSlide = 0) => {
            if (window.innerWidth > 992 && slick.slideCount < 4) {
                $('#mp_counter').css('display', 'none');
            }

            if (window.innerWidth < 992 && slick.slideCount < 3) {
                $('#mp_counter').css('display', 'none');
            }

            if (window.innerWidth < 768 && slick.slideCount < 2) {
                $('#mp_counter').css('display', 'none');
            }
        });
        $('#products_slider').on('afterChange', (event, slick, currentSlide = 0) => {
            let i = currentSlide - 1;
            if (window.innerWidth < 1200) {
                i = currentSlide;
            }
            if (i === 1) {
                $('#psc__prev').addClass('btn-disabled');
            } else {
                $('#psc__prev').removeClass('btn-disabled');
            }
            if (i <= 0) {
                setTimeout(() => {
                    slick.slickNext();
                }, 100);
                i = 1;
            }
            if (i > slick.slideCount - 2) {
                setTimeout(() => {
                    slick.slickPrev();
                }, 100);
                i = slick.slideCount - 2;
            }
            if (i === slick.slideCount - 2) {
                $('#psc__next').addClass('btn-disabled');
            } else {
                $('#psc__next').removeClass('btn-disabled');
            }
            $('#counter__text').text(`${i} / ${slick.slideCount - 2}`);
        });

        $('#products_slider').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: true,
            variableWidth: true,
            swipeToSlide: true,
            initialSlide: 2,
            infinite: false,
            prevArrow: '#psc__prev',
            nextArrow: '#psc__next',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        initialSlide: 1
                    }
                }
            ]
        });
        //--------------------------
        //--------------------------

        //--------------------------
        // Main page hero slider
        $('#mainSlider').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            useTransition: true,
            slidesToShow: 1,
            dots: true,
            appendDots: '#insertDots',
            touchMove: false,
            swipeToSlide: false,
            draggable: false,
            prevArrow: '#ms__prev',
            nextArrow: '#ms__next',
            infinite: false
        });
        //--------------------------
        //--------------------------

        //--------------------------
        // Highlighted reference slider
        $('#hrfSlider').slick({
            slidesToShow: 1,
            prevArrow: '#hrf__prev',
            nextArrow: '#hrf__next',
            infinite: false,
            touchMove: false,
            draggable: false,
            swipeToSlide: false,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false
        });

        $('#hrfSlider').on('init reInit afterChange', (event, slick, currentSlide = 0) => {
            $('#hrf__counter__text').text(`${currentSlide + 1} / ${slick.slideCount}`);
        });
        //--------------------------
        //--------------------------

        //--------------------------
        // About page slider

        $('#aboutSlider').on('init reInit', (event, slick, currentSlide = 0) => {
            if (window.innerWidth > 1200 && slick.slideCount < 4) {
                $('#mp_counter').css('display', 'none');
            }
            if (window.innerWidth < 1200 && slick.slideCount < 2) {
                $('#mp_counter').css('display', 'none');
            }
        });

        $('#aboutSlider').on('afterChange', (event, slick, currentSlide = 0) => {
            let i = currentSlide - 1;
            if (window.innerWidth < 1200) {
                i = currentSlide;
            }
            if (i === 1) {
                $('#about__prev').addClass('btn-disabled');
            } else {
                $('#about__prev').removeClass('btn-disabled');
            }
            if (i <= 0) {
                setTimeout(() => {
                    slick.slickNext();
                }, 100);
                i = 1;
            }
            if (i > slick.slideCount - 2) {
                setTimeout(() => {
                    slick.slickPrev();
                }, 100);
                i = slick.slideCount - 2;
            }
            if (i === slick.slideCount - 2) {
                $('#about__next').addClass('btn-disabled');
            } else {
                $('#about__next').removeClass('btn-disabled');
            }
            $('#about__counter__text').text(`${i} / ${slick.slideCount - 2}`);
        });

        $('#aboutSlider').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: true,
            variableWidth: true,
            swipeToSlide: true,
            initialSlide: 2,
            infinite: false,
            nextArrow: $('#about__next'),
            prevArrow: $('#about__prev'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        initialSlide: 1
                    }
                }
            ]
        });
        //--------------------------
        //--------------------------

        // Products gallery slider
        $('#productGalerySlider').on('init reInit', (event, slick, currentSlide = 0) => {
            if (window.innerWidth > 1200 && slick.slideCount < 4) {
                $('#mp_counter').css('display', 'none');
            }
            if (window.innerWidth < 1200 && slick.slideCount < 2) {
                $('#mp_counter').css('display', 'none');
            }
        });

        const galeryCount = $('#productGalerySlider .sliderItem').length - 2;
        console.log(galeryCount);

        let initialSlide = 2;
        let autoplay = true;
        if (galeryCount < 3) {
            initialSlide = 1;
            autoplay = false;
        }
        if (galeryCount === 3) {
            $('#about__counter__text').text(`2 / ${galeryCount}`);
        }

        $('#productGalerySlider').on('afterChange', (event, slick, currentSlide = 0) => {
            let i = currentSlide - 1;
            if (window.innerWidth < 1200 || galeryCount < 4) {
                i = currentSlide;
            }
            if (i === 1) {
                $('#about__prev').addClass('btn-disabled');
            } else {
                $('#about__prev').removeClass('btn-disabled');
            }
            if (i <= 0) {
                setTimeout(() => {
                    slick.slickNext();
                }, 100);
                i = 1;
            }
            if (i > slick.slideCount - 2) {
                setTimeout(() => {
                    slick.slickPrev();
                }, 100);
                i = slick.slideCount - 2;
            }
            if (i === slick.slideCount - 2) {
                $('#about__next').addClass('btn-disabled');
            } else {
                $('#about__next').removeClass('btn-disabled');
            }
            $('#about__counter__text').text(`${i} / ${slick.slideCount - 2}`);
        });

        $('#productGalerySlider').slick({
            autoplay,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: true,
            variableWidth: true,
            swipeToSlide: true,
            initialSlide,
            infinite: false,
            nextArrow: $('#about__next'),
            prevArrow: $('#about__prev'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        initialSlide: 1
                    }
                }
            ]
        });

        // Handle products page

        const products = $('.item');
        const moreButton = $('.more');

        if (products.length > 3) {
            moreButton.show();
        }

        moreButton.on('click', showMore);

        function showMore() {
            if ($('.item--hidden').length != 0) {
                $('.item--hidden').each(function(index) {
                    if (index === 6) {
                        return;
                    }
                    $(this).removeClass('item--hidden');
                });

                if ($('.item--hidden').length == 0) {
                    moreButton.hide();
                }
            } else {
                moreButton.hide();
            }
        }
    });
})(jQuery);
